export enum Leads {
  Everyone,
  SpecificAdvisors,
}

export const LEADS_OPTIONS = [
  {
    value: Leads.Everyone,
    label: 'Everyone',
  },
  {
    value: Leads.SpecificAdvisors,
    label: 'Specific advisors',
  },
];
